/* eslint-disable */
import ko from 'knockout';
export default function (model) {
  this.hasDetails = model.hasDetails;
  this.showDetails = ko.observable(false);
}

